import { render, staticRenderFns } from "./proLanding.vue?vue&type=template&id=90948652&scoped=true&"
import script from "./proLanding.vue?vue&type=script&lang=js&"
export * from "./proLanding.vue?vue&type=script&lang=js&"
import style0 from "./proLanding.vue?vue&type=style&index=0&id=90948652&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90948652",
  null
  
)

export default component.exports